{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"__experimental": true,
	"apiVersion": 3,
	"name": "core/tabs",
	"title": "Tabs",
	"description": "Display content in a tabbed interface to help users navigate detailed content with ease.",
	"version": "1.0.0",
	"category": "design",
	"textdomain": "default",
	"allowedBlocks": [ "core/tabs-menu", "core/tab-panel" ],
	"attributes": {
		"activeTabIndex": {
			"type": "number",
			"default": 0
		},
		"editorActiveTabIndex": {
			"type": "number",
			"role": "local"
		}
	},
	"supports": {
		"align": true,
		"anchor": true,
		"color": {
			"text": true,
			"background": true,
			"__experimentalDefaultControls": {
				"text": true,
				"background": true
			}
		},
		"layout": {
			"default": {
				"type": "flex",
				"flexWrap": "nowrap",
				"justifyContent": "stretch",
				"verticalAlignment": "stretch",
				"orientation": "vertical"
			},
			"allowSwitching": false,
			"allowVerticalAlignment": true,
			"allowJustification": true,
			"allowOrientation": true,
			"allowSizingOnChildren": true
		},
		"html": false,
		"interactivity": true,
		"spacing": {
			"blockGap": true,
			"margin": true,
			"padding": true
		},
		"typography": {
			"fontSize": true,
			"__experimentalFontFamily": true
		},
		"renaming": true
	},
	"providesContext": {
		"core/tabs-activeTabIndex": "activeTabIndex",
		"core/tabs-editorActiveTabIndex": "editorActiveTabIndex"
	},
	"usesContext": [ "core/tabs-list", "core/tabs-id" ],
	"editorScript": "file:./index.js",
	"editorStyle": "file:./index.css",
	"style": "file:./style-index.css",
	"viewScriptModule": "@wordpress/block-library/tabs/view"
}
